module.exports = __webpack_public_path__ + "static/media/Hbook-12.0a5ca914.jpg";